import { Button, CloseButton, Dialog, Flex, IconButton, Portal, useDisclosure } from '@chakra-ui/react';
import { FC } from 'react';
import useLanguageSelector from '../../../../hooks/useLanguageSelector';
import { MdClose } from 'react-icons/md';
type Props = {
  isOpen: boolean;
  onCloseModal: () => void;
  onLeave: () => void;
};
const LeaveModal: FC<Props> = (props) => {
  const { isOpen, onCloseModal, onLeave } = props;
  const LANG = useLanguageSelector();

  const dialogCloseProps: Dialog.CloseTriggerProps = {
    asChild: true
  };
  const onOpenClose = (details: any) => {
    // リファレンス通りOpenChangeDetailsにしても型読めず
    if (!details.open) {
      onCloseModal();
    }
  };
  const onLeaveClick = () => {
    onLeave();
  };
  return (
    <Dialog.Root open={isOpen} size={'md'} placement={'center'} onOpenChange={onOpenClose}>
      <Portal>
        <Dialog.Positioner>
          <Dialog.Backdrop />
          <Dialog.Content>
            <Dialog.CloseTrigger {...dialogCloseProps}>
              <CloseButton />
            </Dialog.CloseTrigger>
            <Dialog.Header>
              <Dialog.Title>{LANG.KT_0100_30}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Footer>
              <Flex gap={'10px'}>
                <Dialog.ActionTrigger asChild>
                  <Button color={'#fff'} colorPalette={'blue'}>
                    {LANG.KT_0100_32}
                  </Button>
                </Dialog.ActionTrigger>
                <Dialog.ActionTrigger asChild>
                  <Button color={'#fff'} colorPalette={'red'} onClick={onLeaveClick}>
                    {LANG.KT_0100_31}
                  </Button>
                </Dialog.ActionTrigger>
              </Flex>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
export default LeaveModal;
